import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Diamond_Drilling() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>          קידוחי יהלום</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Diamond_Drilling">   קידוחי יהלום</Link>{" "}
</div>
    </div>
    
        <div className="video-line" />

<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/LxJ3YANZ4sU?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>

</div>

 


      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
קידוחי יהלום   </div>
    <div className="content-row2">



      <div className="text-box">
 






  <h2 className="info-title">אנו באיטומים בגבהים מבצעים קידוחי יהלום לכל מטרה פתחי ניקוז, פתחי השחלת צינורות מיזוג, פתחי מעבר לכבלים, פתחי אוורור ועוד ע"י מכונת קידוח יהלום מיוחדת בקטרים של עד-8 צול.





</h2>




      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Identifying_moisture_sources" className="link-right" >    זיהוי מקורות רטיבות  </Link>
  <Link to="/Painting_work_for_the_purpose_of_sealing" className="link-left" >   עבודות צביעה למטרת איטום וצביעה בגבהים   </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


